import React, { Component } from "react";
import PropTypes from "prop-types";
import { TextArea, Button } from "@sainsburys-tech/fable";
import ButtonGroup from "../ButtonGroup";
import * as maxLengths from "../../model/alert-comments/maxLengths";
import LoadingWrapper from "../LoadingWrapper";
import FormWrapper from "../FormWrapper";

class AlertCommentForm extends Component {
  state = {
    alertComment: {
      content: ""
    },
    isSubmitting: false,
    isDirty: false
  };

  handleInputChange = (inputName, inputValue) => {
    this.setState(prevState => ({
      alertComment: {
        ...prevState.alertComment,
        [inputName]: inputValue
      },
      isDirty: true
    }));
  };

  handleSubmit = () => {
    if (!this.validate()) {
      return;
    }

    this.setState({ isSubmitting: true });

    const alertComment = this.state.alertComment;

    this.props.createAlertComment(alertComment.content, () => {
      this.setState({ isSubmitting: false });
      this.props.onAlertCommentCreated();
    });
  };

  validate = () => {
    const content = this.state.alertComment.content;

    if (!content || content.trim().length === 0) return false;
    if (content.length > maxLengths.CONTENT) {
      return false;
    }

    return true;
  };

  render() {
    return (
      <FormWrapper isDirty={this.state.isDirty}>
        <TextArea
          placeholder="What's new?"
          label="Add a comment"
          maxLength={maxLengths.CONTENT}
          name="content"
          onChange={(value) => this.handleInputChange("content", value)}
          disabled={this.state.isSubmitting}
        />
        <LoadingWrapper isLoading={this.state.isSubmitting}>
            <Button
              variant="primary"
              disabled={this.state.isSubmitting || !this.validate()}
              onClick={() => this.handleSubmit()}
              style={{
                marginTop: '20px',
                ...(this.state.isSubmitting || !this.validate() ? { backgroundColor: '#8c8c8c', borderColor: '#8c8c8c' } : {})
              }}
            >
              Comment
            </Button>
        </LoadingWrapper>
      </FormWrapper>
    );
  }
}

AlertCommentForm.propTypes = {
  onAlertComentCreated: PropTypes.func
};

export default AlertCommentForm;
